import { useId, useState } from 'react';

const MAX_SUGGESTIONS = 6;

// Ô tìm kiếm có gợi ý ngay khi gõ (dùng cho danh mục ở trang chủ và tranh trong trang danh mục).
// describe(item) -> { key, title, sub } để hiện một dòng gợi ý; matches(item, query) quyết định item có khớp không.
export default function SearchBar({ items, matches, describe, query, onQueryChange, onPick, placeholder, emptyText }) {
  const listId = useId(); // mỗi ô tìm kiếm một mã riêng (trang có thể có 2 ô cùng lúc)
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1); // gợi ý đang chọn bằng phím mũi tên

  const suggestions = query.trim() ? (items || []).filter((item) => matches(item, query)).slice(0, MAX_SUGGESTIONS) : [];
  const showList = open && query.trim() !== '';

  const pick = (item) => {
    setOpen(false);
    setActive(-1);
    onPick(item);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setOpen(true);
      setActive((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive((i) => Math.max(i - 1, -1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (active >= 0 && suggestions[active]) pick(suggestions[active]);
      else setOpen(false); // danh sách bên dưới đã tự lọc theo chữ đang gõ
    } else if (e.key === 'Escape') {
      setOpen(false);
    }
  };

  return (
    <div className="searchbar">
      <span className="searchbar-icon" aria-hidden="true">
        ⌕
      </span>
      <input
        type="search"
        value={query}
        onChange={(e) => {
          onQueryChange(e.target.value);
          setOpen(true);
          setActive(-1);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        aria-label={placeholder}
        role="combobox"
        aria-expanded={showList}
        aria-controls={listId}
        autoComplete="off"
      />

      {showList && (
        <ul className="suggestions" id={listId} role="listbox">
          {suggestions.length === 0 && <li className="suggestion-empty">{emptyText}</li>}
          {suggestions.map((item, i) => {
            const { key, title, sub } = describe(item);
            return (
              <li
                key={key}
                role="option"
                aria-selected={i === active}
                className={`suggestion ${i === active ? 'active' : ''}`}
                // mousedown thay vì click để chạy trước khi ô tìm kiếm mất focus (onBlur đóng danh sách)
                onMouseDown={(e) => {
                  e.preventDefault();
                  pick(item);
                }}
                onMouseEnter={() => setActive(i)}
              >
                <span className="suggestion-text">
                  <strong>{title}</strong>
                  {sub && <span>{sub}</span>}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
